import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=cb7c33ca&scoped=true&"
import script from "./Changelog.vue?vue&type=script&lang=ts&"
export * from "./Changelog.vue?vue&type=script&lang=ts&"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=cb7c33ca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7c33ca",
  null
  
)

export default component.exports